module.exports = __webpack_public_path__ + "static/media/model-3.36f29135.jpg";